<app-navbar-style-one></app-navbar-style-one>

<div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>Privacy Policy </h2>
                    <p class="mt-4 mb-0 mx-3">Welcome to <strong>Fontana</strong> Privacy Policy

Fontana respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your information when you interact with us—whether in person, online, or through third-party delivery platforms.</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/cart.png" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div>

<div class="privacy-policy-area ptb-100">
    <div class="container">
        <div class="single-content">
            <h3>Welcome to FONTANA Privacy Policy</h3>
            <div class="terms-content" [innerHTML]="settings"></div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>